module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Regular.woff
// module id = 1577
// module chunks = 57